import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Banking account number is a string of 5 to 17 alphanumeric values for representing an generic account number */
  AccountNumber: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: any;
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: any;
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: any;
  /** A field whose value is a Currency: https://en.wikipedia.org/wiki/ISO_4217. */
  Currency: any;
  /** A field whose value conforms to the standard DID format as specified in did-core: https://www.w3.org/TR/did-core/. */
  DID: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  Duration: any;
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  GUID: any;
  /** A field whose value is a CSS HSL color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSL: any;
  /** A field whose value is a CSS HSLA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#hsl()_and_hsla(). */
  HSLA: any;
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: any;
  /** A field whose value is a hexadecimal: https://en.wikipedia.org/wiki/Hexadecimal. */
  Hexadecimal: any;
  /** A field whose value is an International Bank Account Number (IBAN): https://en.wikipedia.org/wiki/International_Bank_Account_Number. */
  IBAN: any;
  /** A field whose value is a IPv4 address: https://en.wikipedia.org/wiki/IPv4. */
  IPv4: any;
  /** A field whose value is a IPv6 address: https://en.wikipedia.org/wiki/IPv6. */
  IPv6: any;
  /** A field whose value is a ISBN-10 or ISBN-13 number: https://en.wikipedia.org/wiki/International_Standard_Book_Number. */
  ISBN: any;
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  ISO8601Duration: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: any;
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: any;
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: any;
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`.  This scalar is very similar to the `LocalTime`, with the only difference being that `LocalEndTime` also allows `24:00` as a valid value to indicate midnight of the following day.  This is useful when using the scalar to represent the exclusive upper bound of a time block. */
  LocalEndTime: any;
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: any;
  /** The locale in the format of a BCP 47 (RFC 5646) standard string */
  Locale: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  Long: any;
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: any;
  /** A field whose value is a IEEE 802 48-bit MAC address: https://en.wikipedia.org/wiki/MAC_address. */
  MAC: any;
  /** Floats that will have a value less than 0. */
  NegativeFloat: any;
  /** Integers that will have a value less than 0. */
  NegativeInt: any;
  /** A string that cannot be passed as an empty value */
  NonEmptyString: any;
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: any;
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: any;
  /** Floats that will have a value of 0 or less. */
  NonPositiveFloat: any;
  /** Integers that will have a value of 0 or less. */
  NonPositiveInt: any;
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: any;
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: any;
  /** A field whose value is a valid TCP port within the range of 0 to 65535: https://en.wikipedia.org/wiki/Transmission_Control_Protocol#TCP_ports */
  Port: any;
  /** Floats that will have a value greater than 0. */
  PositiveFloat: any;
  /** Integers that will have a value greater than 0. */
  PositiveInt: any;
  /** A field whose value conforms to the standard postal code formats for United States, United Kingdom, Germany, Canada, France, Italy, Australia, Netherlands, Spain, Denmark, Sweden, Belgium, India, Austria, Portugal, Switzerland or Luxembourg. */
  PostalCode: any;
  /** A field whose value is a CSS RGB color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGB: any;
  /** A field whose value is a CSS RGBA color: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba(). */
  RGBA: any;
  /** In the US, an ABA routing transit number (`ABA RTN`) is a nine-digit code to identify the financial institution. */
  RoutingNumber: any;
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: any;
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: any;
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: any;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: any;
  /** A currency string, such as $21.25 */
  USCurrency: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: any;
  /** Floats that will have a value of 0 or more. */
  UnsignedFloat: any;
  /** Integers that will have a value of 0 or more. */
  UnsignedInt: any;
  /** A field whose value is a UTC Offset: https://en.wikipedia.org/wiki/List_of_tz_database_time_zones */
  UtcOffset: any;
  /** Represents NULL values */
  Void: any;
};

export type Bid = Node & {
  __typename?: 'Bid';
  active?: Maybe<Scalars['Boolean']>;
  avgBuyPrice: Scalars['Float'];
  avgSellPrice: Scalars['Float'];
  bookProfit: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  items: BidItemConnection;
  metadata?: Maybe<Array<Metadata>>;
  stock: Stock;
  totalBalance: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  user: User;
};


export type BidItemsArgs = {
  filter?: InputMaybe<Array<FilterInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<SorterInput>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type BidAdjustment = Node & {
  __typename?: 'BidAdjustment';
  active?: Maybe<Scalars['Boolean']>;
  amount: Scalars['Float'];
  bid: Bid;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  metadata?: Maybe<Array<Metadata>>;
  type: BidAdjustmentType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
  user: User;
};

export type BidAdjustmentConnection = Connection & {
  __typename?: 'BidAdjustmentConnection';
  /** Base64 encoded cursor for pagination if more records are available. */
  nextCursor?: Maybe<Scalars['ID']>;
  /** Data nodes of current page. */
  nodes: Array<BidAdjustment>;
  /** Total collection count of the current collection. */
  totalCount: Scalars['Int'];
};

export enum BidAdjustmentSearchFields {
  Amount = 'amount',
  BidId = 'bidId',
  Id = 'id',
  Metadata = 'metadata',
  Type = 'type',
  UserId = 'userId'
}

export enum BidAdjustmentType {
  /** 買入手續費 */
  BuyTradingFee = 'BUY_TRADING_FEE',
  /** 股息 */
  Dividend = 'DIVIDEND',
  /** 賣出手續費 */
  SellTradingFee = 'SELL_TRADING_FEE',
  /** 以股代息 */
  Share = 'SHARE'
}

export type BidConnection = Connection & {
  __typename?: 'BidConnection';
  /** Base64 encoded cursor for pagination if more records are available. */
  nextCursor?: Maybe<Scalars['ID']>;
  /** Data nodes of current page. */
  nodes: Array<Bid>;
  /** Total collection count of the current collection. */
  totalCount: Scalars['Int'];
};

export type BidItem = Node & {
  __typename?: 'BidItem';
  active?: Maybe<Scalars['Boolean']>;
  balance?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  metadata?: Maybe<Array<Metadata>>;
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  totalAmount: Scalars['Float'];
  type: BidItemType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
};

export type BidItemConnection = Connection & {
  __typename?: 'BidItemConnection';
  /** Base64 encoded cursor for pagination if more records are available. */
  nextCursor?: Maybe<Scalars['ID']>;
  /** Data nodes of current page. */
  nodes: Array<BidItem>;
  /** Total collection count of the current collection. */
  totalCount: Scalars['Int'];
};

export enum BidItemSearchFields {
  BidId = 'bidId',
  BuyItemId = 'buyItemId',
  Id = 'id',
  Metadata = 'metadata',
  Type = 'type'
}

export enum BidItemType {
  Buy = 'BUY',
  Sell = 'SELL'
}

export enum BidSearchFields {
  Id = 'id',
  Metadata = 'metadata',
  StockId = 'stockId',
  UserId = 'userId'
}

export type BuyBidItemInput = {
  price: Scalars['Float'];
  quantity: Scalars['Int'];
};

/** Base connection for paginated data in the system. */
export type Connection = {
  /** Base64 encoded cursor for pagination if more records are available. */
  nextCursor?: Maybe<Scalars['ID']>;
  /** Total collection count of the current collection. */
  totalCount: Scalars['Int'];
};

export type CreateBidAdjustmentInput = {
  amount: Scalars['Float'];
  bidId: Scalars['ID'];
  date?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<Array<MetadataInput>>;
  type: BidAdjustmentType;
};

export type CreateBuyBidInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  items: Array<BuyBidItemInput>;
  quoteCode: Scalars['String'];
  tradingFee: Scalars['Float'];
};

export type CreateSellBidInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  items: Array<SellBidItemInput>;
  tradingFee: Scalars['Float'];
};

export type CreateStockInput = {
  boardLot: Scalars['Int'];
  code: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['Float'];
};

export type CreateUserInput = {
  email: Scalars['EmailAddress'];
  metadata?: InputMaybe<Array<MetadataInput>>;
  name?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type Filter = {
  __typename?: 'Filter';
  filterValue: FilterValue;
  key: Scalars['String'];
};

export type FilterInput = {
  filterValue: FilterValueInput;
  key: Scalars['String'];
};

export enum FilterOperator {
  /**
   * Between two values.
   *
   * GT, GTE and LT should also use this instead, LTE is removed for simplicity.
   */
  Between = 'BETWEEN',
  /**
   * Strict equality.
   *
   * EQ should be expressed as a single-element IN.
   */
  In = 'IN',
  /** Like (String matching), wildcards % and _ can be used. */
  Like = 'LIKE',
  /** Full text index matching */
  Match = 'MATCH',
  /** Alias of NOT_LIKE, for fun. */
  Nike = 'NIKE',
  /**
   * Strict equality excluison.
   *
   * NE should be expressed as a single-=element NIN.
   */
  Nin = 'NIN',
  /**
   * Like exclusion.
   *
   * Usage is discouraged beacuse NOT expressions easily induces table scans,
   * indexes are usually ignored.
   */
  NotLike = 'NOT_LIKE',
  /**
   * Exclusion of full text matching.
   *
   * Usage is discouraged beacuse NOT MATCH is guaranteed to not use any index.
   */
  NotMatch = 'NOT_MATCH',
  NotNull = 'NOT_NULL',
  Null = 'NULL'
}

export type FilterValue = {
  __typename?: 'FilterValue';
  operator: FilterOperator;
  value: Array<Scalars['String']>;
};

export type FilterValueInput = {
  operator: FilterOperator;
  value: Array<Scalars['String']>;
};

export type Media = {
  __typename?: 'Media';
  alt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Converts the source media into specified size and content type, optionally
   * cropping with the image positioned according to gravity.
   */
  optimizedSrc: Scalars['URL'];
  src: Scalars['URL'];
};


export type MediaOptimizedSrcArgs = {
  contentType?: InputMaybe<MediaContentType>;
  gravity?: InputMaybe<MediaGravity>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};

export enum MediaContentType {
  Gif = 'GIF',
  Jpg = 'JPG',
  Png = 'PNG',
  Tiff = 'TIFF'
}

export enum MediaGravity {
  Center = 'CENTER',
  Centre = 'CENTRE',
  East = 'EAST',
  North = 'NORTH',
  Northeast = 'NORTHEAST',
  Northwest = 'NORTHWEST',
  South = 'SOUTH',
  Southeast = 'SOUTHEAST',
  Southwest = 'SOUTHWEST',
  West = 'WEST'
}

export type MediaInput = {
  alt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<MetadataInput>;
  src?: InputMaybe<Scalars['URL']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type MetadataInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createBidAdjustment: BidAdjustment;
  createBuyBid: Bid;
  createSellBid: Bid;
  dummy?: Maybe<Scalars['String']>;
  register: User;
  removeBid: Bid;
  removeBidAdjustment: BidAdjustment;
  removeBidItem: BidItem;
  sessionCreate: Scalars['String'];
};


export type MutationCreateBidAdjustmentArgs = {
  input: CreateBidAdjustmentInput;
};


export type MutationCreateBuyBidArgs = {
  input: CreateBuyBidInput;
};


export type MutationCreateSellBidArgs = {
  id: Scalars['ID'];
  input: CreateSellBidInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRemoveBidArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveBidAdjustmentArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveBidItemArgs = {
  id: Scalars['ID'];
};


export type MutationSessionCreateArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};

/** Base data node for all entities in the system. */
export type Node = {
  active?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  metadata?: Maybe<Array<Metadata>>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
};

export type Query = {
  __typename?: 'Query';
  bid?: Maybe<Bid>;
  bidAdjustment?: Maybe<BidAdjustment>;
  bidAdjustments: BidAdjustmentConnection;
  bids: BidConnection;
  dummy?: Maybe<Scalars['String']>;
  me?: Maybe<User>;
  stock?: Maybe<Stock>;
  /** Generate a pre-signed URL for S3 upload. */
  uploadUrl: Scalars['URL'];
  user?: Maybe<User>;
  users: UserConnection;
};


export type QueryBidArgs = {
  id: Scalars['ID'];
};


export type QueryBidAdjustmentArgs = {
  id: Scalars['ID'];
};


export type QueryBidAdjustmentsArgs = {
  filter?: InputMaybe<Array<FilterInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<SorterInput>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBidsArgs = {
  filter?: InputMaybe<Array<FilterInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<SorterInput>>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryStockArgs = {
  code: Scalars['String'];
};


export type QueryUploadUrlArgs = {
  input: UploadUrlInput;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<Array<FilterInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<SorterInput>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type RegisterInput = {
  email: Scalars['EmailAddress'];
  metadata?: InputMaybe<Array<MetadataInput>>;
  name?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type SellBidItemInput = {
  buyItemId: Scalars['ID'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SorterInput = {
  field: Scalars['String'];
  order: SortOrder;
};

export type Stock = Node & {
  __typename?: 'Stock';
  active?: Maybe<Scalars['Boolean']>;
  boardLot: Scalars['Int'];
  changes?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  metadata?: Maybe<Array<Metadata>>;
  name: Scalars['String'];
  price: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
};

export type Subscription = {
  __typename?: 'Subscription';
  dummy?: Maybe<Scalars['String']>;
};

export type UpdateStockInput = {
  boardLot?: InputMaybe<Scalars['Int']>;
  code: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['EmailAddress']>;
  metadata?: InputMaybe<Array<MetadataInput>>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type UploadUrlInput = {
  /** Description of the uploaded file, reserved for future use. */
  description?: InputMaybe<Scalars['String']>;
  /** Desinated mime type of the file to be uploaded, this affects the resulting file extension. */
  mime?: InputMaybe<Scalars['String']>;
};

export type User = Node & {
  __typename?: 'User';
  active?: Maybe<Scalars['Boolean']>;
  bid?: Maybe<Bid>;
  bids: BidConnection;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  metadata?: Maybe<Array<Metadata>>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  totalBookProfit: Scalars['Float'];
  totalCost: Scalars['Float'];
  totalDividend: Scalars['Float'];
  totalPrice: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<User>;
};


export type UserBidArgs = {
  id: Scalars['ID'];
};


export type UserBidsArgs = {
  filter?: InputMaybe<Array<FilterInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  sorter?: InputMaybe<Array<SorterInput>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type UserConnection = Connection & {
  __typename?: 'UserConnection';
  /** Base64 encoded cursor for pagination if more records are available. */
  nextCursor?: Maybe<Scalars['ID']>;
  /** Data nodes of current page. */
  nodes: Array<User>;
  /** Total collection count of the current collection. */
  totalCount: Scalars['Int'];
};

export enum UserSearchFields {
  Email = 'email',
  Id = 'id',
  Metadata = 'metadata',
  Name = 'name',
  PhoneNumber = 'phoneNumber'
}

export type CreateBidAdjustmentMutationVariables = Exact<{
  input: CreateBidAdjustmentInput;
}>;


export type CreateBidAdjustmentMutation = { __typename?: 'Mutation', createBidAdjustment: { __typename?: 'BidAdjustment', id: string, updatedAt: any, createdAt: any, active?: boolean | null, amount: number, type: BidAdjustmentType } };

export type CreateBuyBidMutationVariables = Exact<{
  input: CreateBuyBidInput;
}>;


export type CreateBuyBidMutation = { __typename?: 'Mutation', createBuyBid: { __typename?: 'Bid', id: string, updatedAt: any, createdAt: any, active?: boolean | null, avgBuyPrice: number, avgSellPrice: number, totalBalance: number, bookProfit: number, metadata?: Array<{ __typename?: 'Metadata', key: string, value: string }> | null, stock: { __typename?: 'Stock', id: string, code: string, name: string, changes?: string | null, price: number } } };

export type CreateSellBidMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CreateSellBidInput;
}>;


export type CreateSellBidMutation = { __typename?: 'Mutation', createSellBid: { __typename?: 'Bid', id: string, updatedAt: any, createdAt: any, active?: boolean | null, avgBuyPrice: number, avgSellPrice: number, totalBalance: number, bookProfit: number, metadata?: Array<{ __typename?: 'Metadata', key: string, value: string }> | null, stock: { __typename?: 'Stock', id: string, code: string, name: string, changes?: string | null, price: number } } };

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'User', id: string, name?: string | null, phoneNumber?: any | null, email: string } };

export type RemoveBidMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveBidMutation = { __typename?: 'Mutation', removeBid: { __typename?: 'Bid', id: string } };

export type RemoveBidItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveBidItemMutation = { __typename?: 'Mutation', removeBidItem: { __typename?: 'BidItem', id: string } };

export type SessionCreateMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type SessionCreateMutation = { __typename?: 'Mutation', sessionCreate: string };

export type MeBidQueryVariables = Exact<{
  id: Scalars['ID'];
  filter?: InputMaybe<Array<FilterInput> | FilterInput>;
  sorter?: InputMaybe<Array<SorterInput> | SorterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type MeBidQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, updatedAt: any, createdAt: any, name?: string | null, phoneNumber?: any | null, email: string, metadata?: Array<{ __typename?: 'Metadata', key: string, value: string }> | null, bid?: { __typename?: 'Bid', id: string, updatedAt: any, createdAt: any, active?: boolean | null, avgBuyPrice: number, avgSellPrice: number, totalBalance: number, bookProfit: number, metadata?: Array<{ __typename?: 'Metadata', key: string, value: string }> | null, stock: { __typename?: 'Stock', id: string, code: string, name: string, changes?: string | null, price: number }, items: { __typename?: 'BidItemConnection', totalCount: number, nextCursor?: string | null, nodes: Array<{ __typename?: 'BidItem', id: string, updatedAt: any, createdAt: any, active?: boolean | null, price: number, quantity: number, balance?: number | null, totalAmount: number, type: BidItemType, metadata?: Array<{ __typename?: 'Metadata', key: string, value: string }> | null }> } } | null } | null };

export type MeBidsQueryVariables = Exact<{
  filter?: InputMaybe<Array<FilterInput> | FilterInput>;
  sorter?: InputMaybe<Array<SorterInput> | SorterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type MeBidsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, updatedAt: any, createdAt: any, name?: string | null, phoneNumber?: any | null, email: string, totalCost: number, totalPrice: number, totalDividend: number, totalBookProfit: number, metadata?: Array<{ __typename?: 'Metadata', key: string, value: string }> | null, bids: { __typename: 'BidConnection', totalCount: number, nextCursor?: string | null, nodes: Array<{ __typename?: 'Bid', id: string, updatedAt: any, createdAt: any, active?: boolean | null, avgBuyPrice: number, avgSellPrice: number, totalBalance: number, bookProfit: number, metadata?: Array<{ __typename?: 'Metadata', key: string, value: string }> | null, stock: { __typename?: 'Stock', id: string, code: string, name: string, changes?: string | null, price: number } }> } } | null };

export type StockQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type StockQuery = { __typename?: 'Query', stock?: { __typename?: 'Stock', id: string, name: string, price: number } | null };


export const CreateBidAdjustmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBidAdjustment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBidAdjustmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBidAdjustment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<CreateBidAdjustmentMutation, CreateBidAdjustmentMutationVariables>;
export const CreateBuyBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBuyBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBuyBidInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBuyBid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avgBuyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgSellPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"bookProfit"}},{"kind":"Field","name":{"kind":"Name","value":"stock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"changes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBuyBidMutation, CreateBuyBidMutationVariables>;
export const CreateSellBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSellBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSellBidInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSellBid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avgBuyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgSellPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"bookProfit"}},{"kind":"Field","name":{"kind":"Name","value":"stock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"changes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSellBidMutation, CreateSellBidMutationVariables>;
export const RegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Register"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const RemoveBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeBid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveBidMutation, RemoveBidMutationVariables>;
export const RemoveBidItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveBidItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeBidItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveBidItemMutation, RemoveBidItemMutationVariables>;
export const SessionCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SessionCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<SessionCreateMutation, SessionCreateMutationVariables>;
export const MeBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SorterInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avgBuyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgSellPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"bookProfit"}},{"kind":"Field","name":{"kind":"Name","value":"stock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"changes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sorter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sorter"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeBidQuery, MeBidQueryVariables>;
export const MeBidsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeBids"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorter"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SorterInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalDividend"}},{"kind":"Field","name":{"kind":"Name","value":"totalBookProfit"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bids"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sorter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sorter"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avgBuyPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgSellPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalBalance"}},{"kind":"Field","name":{"kind":"Name","value":"bookProfit"}},{"kind":"Field","name":{"kind":"Name","value":"stock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"changes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeBidsQuery, MeBidsQueryVariables>;
export const StockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Stock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<StockQuery, StockQueryVariables>;